<div class="valuation-tab-container">
  <div class="valuation-tab-top-action-container">
    <div class="valuation-filter-container">
      <div class="valuation-filter">
        <div class="valuation-peer-ticker">
          <label class="valuation-filter-label">Peers</label>
          <app-ticker-search
            [tickers]="tickerIds"
            [onScreen]="true"
            [isComp]="true"
            (onSearchedTickerUpdate)="handleSearchTickerSelection($event)"
            [hasSearchIcon]="true"
            [disabled]="
              !isTickerFilterDataReady ||
              isTickerUpdationInProgress ||
              !isMetaReady
            "
            [suggestedTickers]="suggestedPeers"
            placeholder="&nbsp;Add Peers"
            maxSelectedTickerCount="50"
          ></app-ticker-search>
          <button
            nz-button
            class="on-screen-search__edit-btn"
            (click)="handleEditTickerClick()"
            [disabled]="
              !isTickerFilterDataReady ||
              isTickerUpdationInProgress ||
              !isMetaReady ||
              isUserSettingsInProgress
            "
          >
            Edit
          </button>
        </div>
      </div>
      <div class="valuation-filter">
        <div class="valuation-ratio-box">
          <app-lineitem-filter
            [options]="ratioLineItemsData"
            [selectedValue]="{}"
            [selectedOptionsId]="selectedRatioId"
            liFilterId="valuationPeersLI"
            [bottomBorderView]="true"
            [disabled]="
              !isMetaReady ||
              isUserSettingsInProgress ||
              !state ||
              !isLineItemDataReady
            "
            placeholder="&nbsp;Add Ratios"
            label="Ratios"
            [showButton]="true"
            (onValueChange)="onSearchedLi($event)"
            (onEditButtonClick)="handleEditLineItemsButtonClick()"
          ></app-lineitem-filter>
        </div>
      </div>
      <div class="valuation-filter">
        <va-period-filter
          [filterWidthVariation]="3"
          [periodData]="state ? state.period : undefined"
          [disabled]="
            !isMetaReady || isUserSettingsInProgress || !state || !state.period
          "
          (onApply)="handlePeriodApply($event)"
          [dataAvailable]="periodsWithAvailableData"
        ></va-period-filter>
      </div>
      <div class="valuation-filter">
        <va-currency-select
          size="small"
          selectWidth="78"
          labelPlacement="top"
          [bottomBorderView]="true"
          [selectedCurrency]="state ? state.currency : undefined"
          [apiEP]="apiEP"
          apiUrl="/api/get_available_currencies"
          (onChange)="updateCurrency($event)"
          [disabled]="
            !isMetaReady || currencyUpdating || isUserSettingsInProgress
          "
        ></va-currency-select>
      </div>
    </div>

    <div class="valuation-cta-right-section">
      <div class="valuation-cta-item valuation-switch-item">
        <nz-radio-group
          [ngModel]="orientationValue"
          [nzButtonStyle]="'solid'"
          (ngModelChange)="handleOrientation($event)"
          [disabled]="isUserSettingsInProgress || !isMetaReady"
          style="font-size: 12px"
        >
          <label nz-radio-button nzValue="grid" class="label-name">
            <va-icon size="small" name="table" class="icon"></va-icon
            >Grid</label
          >
          <label nz-radio-button nzValue="list" class="label-name">
            <va-icon size="small" name="menu" class="icon"></va-icon>List</label
          >
        </nz-radio-group>
      </div>
      <app-export-to-excel-dropdown
        [(isPopoverVisible)]="isExportPopoverVisible"
        [disabled]="!isMetaReady || isUserPeriodCalSettingsInProgress"
        [optionList]="excelToExportDropdownOptions"
        [isExportInProgress]="isExportInProgress"
        (onListItemClick)="handleETEListItemClick($event)"
      ></app-export-to-excel-dropdown>
    </div>
  </div>
  <div class="grid-section">
    <ng-container *ngIf="orientationValue === 'grid'">
      <div style="padding-top: 16px">
        <app-valuation-grid
          [gridData]="gridData"
          [showAverage]="true"
          [showMedian]="true"
          [orientation]="orientationValue"
          [periodState]="state ? state.period : undefined"
          [highlightGAAP]="highlightGAAP"
          [visible]="visible"
          [isDataInProgress]="isDataInProgress"
          (onDeleteTicker)="handleOnDeleteTicker($event)"
        ></app-valuation-grid>
      </div>
    </ng-container>
    <ng-container *ngIf="orientationValue === 'list'">
      <ng-container *ngFor="let ratio of gridData.ratios">
        <ng-container *ngIf="ratio.charAt(0) !== '#'">
          <div style="padding-top: 16px">
            <app-valuation-grid
              [gridData]="gridData"
              [showAverage]="true"
              [showMedian]="true"
              [orientation]="orientationValue"
              [ratioId]="ratio"
              [periodState]="state ? state.period : undefined"
              [highlightGAAP]="highlightGAAP"
              [visible]="visible"
              [isDataInProgress]="isDataInProgress"
              (onDeleteTicker)="handleOnDeleteTicker($event)"
            ></app-valuation-grid>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</div>
